import api from './api';

export interface VereadorDashboardDTO {
  parlamentarId: string;
  nome: string;
  partido: string;
  limiteAnual: number;
  valorSaude: number;
  valorEducacao: number;
  valorOutras: number;
  totalUsado: number;
  percentualSaude: number;
  percentualEducacao: number;
  percentualLimite: number;
  alertaSaude: boolean;
  alertaEducacao: boolean;
}

export interface KpisDTO {
  totalEmpenhado: number;
  totalSaude: number;
  totalEducacao: number;
  totalOutras: number;
  percentualSaudeGeral: number;
  percentualEducacaoGeral: number;
  countCotaAtingida: number;
  countAlerta: number;
  countPendente: number;
}

export interface DashboardEmendaResponseDTO {
  ano: number;
  kpis: KpisDTO;
  vereadores: VereadorDashboardDTO[];
  thresholdSaude: number;
  thresholdEducacao: number;
  categoriasAtivas: string[];
}

const dashboardEmendaService = {
  getConsolidado: async (ano?: number): Promise<DashboardEmendaResponseDTO> => {
    const params = ano ? { ano } : {};
    const res = await api.get('/dashboard/emendas', { params });
    return res.data;
  },

  getAnosDisponiveis: async (): Promise<number[]> => {
    const res = await api.get('/dashboard/emendas/anos');
    return res.data;
  },
};

export default dashboardEmendaService;
